export interface UserSignatureResponse {
  secureId: string;
}

export interface FeatureTogglesModel {
  secureId: string;
}

export interface FeatureTogglesDtoModel {
  secureId: string;
}

export enum FeatureFlag {
  ModuleScimAccountSettings = "enable-scim-account-settings",
  RestConnector = "restconnector",
  RestConnectorOAuth = "restconnectoroauth",
  AzureDevopsCDataConnector = "azure-dev-ops-c-data-connector",
  FeatureWhiteboardBasicShapes = "whiteboard-basic-shapes",
  MarketplaceDirectSubmissionOfInsights = "marketplace_direct_submission_of_insights",
  NewExperienceOnboarding = "new-experience-onboarding",
  LockMultiAccount = "lock-multi-account",
  EnableTagManagement = "enable-tag-management",
  EnableInsightRenderingOptimisations = "enable-insight-rendering-optimisations",
  ChartsInLists = "charts-in-lists",
  ShowTheUserWhoCreated = "show-the-user-who-created",
  OrganizationChartV2 = "organization-chart-v2", // TODO enabled should be removed
  OrganizationChartV3 = "organization-chart-v3", // TODO enabled should be removed
  HideExternalTeams = "hide-external-teams",
  FeatureSSOSettings = "sso-settings",
  WhiteboardsSessionManagement = "whiteboards-session-management",
  WorkdayProvisioning = "workday-provisioning",
  FeatureReflections = "reflections",
  ActivityHistory = "audit-trail",
  HideKPIsPermissions = "hide-kpis-permissions",
  AlignmentTreeDragOrPointerNavigation = "alignment-tree-dragging-tool",
  WhiteboardDragOrPointerNavigation = "whiteboard-dragging-tool",
  insightSuggestions = "insight-suggestions",
  DisableDelightedSurveys = "disable-delighted-surveys",
  MandatoryOkrAlignmentFeature = "mandatory-alignment-of-okrs",
  SCIMGroups = "scim-groups",
  DisableTasksFromDesignScore = "disable-tasks-from-design-score",
  NavControlsOnboarding = "nav-controls-onboarding",
  QuantivePlusSuggestions = "kr-tenx-suggestions",
  OkrFiltersImprovement = "okr-filters-improvement",
  SlackChannelDropdownDisabled = "slack-channel-dropdown-disabled",
  a11yUpdateKrForm = "a11y-update-kr-form",
  KpiComments = "kpi-comments",
  QuantivePlusWizard = "quantive-plus-wizard",
  ShareableLinksWithAppliedFilters = "shareable-links-with-applied-filters",
  FeatureSmartAlignment = "smart-alignment",
  UploadMediaAvatar = "upload-medi-avatar",
  PiSuggestionDrawerOverviewTab = "pi-suggestion-drawer-overview-tab",
  PiSuggestionDrawerEffectivenessTab = "pi-suggestion-drawer-effectiveness-tab",
  PiSuggestionDrawerAllSuggestionsTab = "pi-suggestion-drawer-all-suggestions-tab",
  PiSuggestionDrawerWhenCreateObjective = "pi-suggestion-drawer-when-create-objective",
  PiSuggestionDrawerWhenCreateKr = "pi-suggestion-drawer-when-create-kr",
  PiSettings = "pi-settings",
  RelatedItems = "related-items",
  A14AutomateKeyResultModal = "a14-automate-key-result-modal",
  A14UpdateKeyResult = "a14-update-key-result",
  PowerBI = "power-bi",
  UiLoadingIndicator = "ui-loading-indicator",
  WhiteboardTemplates = "whiteboard-templates",
  BypassManageDataPermission = "bypass-manage-data-permission",
  PrivacyNotice = "privacy-notice",
  A14OkrTasks = "a14-okr-tasks",
  Arabic = "arabic",
  QuantiveStaticCdn = "quantivestatic-cdn",
  OkrViews = "okr-views",
  AccountMarketingInfo = "account-marketing-info",
  WhiteboardAndReportsNotifications = "reports-whiteboards-notifications",
  CheckInsUxImprovements = "check-ins-ux-improvements",
  PiWhiteboardSuggestions = "pi-whiteboard-suggestions",
  PiContextualSuggestions = "pi-contextual-suggestions",
  AchievedOrNotMetricType = "achieved-or-not-metric-type",
  SessionsInsightboardsKpisNotifications = "sessions-insightboards-kpis-notifications",
  MetricMilestone = "metric-milestone",
  CloneAndMoveOkrModal = "a14-clone-and-move-modals",
}
